import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { reloadOnce } from '../lib/reload-once';

/** Shown instead of a blank screen when a page throws. */
export function ErrorPage() {
  const error = useRouteError();
  const detail = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : String(error);
  // Page file from an older deploy: reload onto the new one.
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  useEffect(() => {
    if (/dynamically imported module|Importing a module script failed|error loading dynamically imported/i.test(detail)) reloadOnce();
  }, [detail]);
  return (
    <main className="grid min-h-dvh place-items-center px-4">
      <div className="max-w-md space-y-3 rounded-dar border border-sand bg-white p-6">
        <h1 className="font-heading text-2xl">صار خطأ بهالصفحة</h1>
        <p className="text-sm text-muted">إعادة تحميل الصفحة ممكن تحل المشكلة. إذا تكررت، هاي تفاصيل الخطأ:</p>
        <pre className="overflow-auto rounded bg-cream p-2 text-xs" dir="ltr">
          {detail}
        </pre>
        <Link to="/" className="inline-block underline underline-offset-4">
          رجوع للرئيسية
        </Link>
      </div>
    </main>
  );
}
